export default "__VITE_ASSET__XptEy9YT__"